// src/components/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUserLevel } from '../services/auth';

const AdminRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }
  const userLevel = getUserLevel();
  if (userLevel === 'admin') {
    return children;
  } else {
    return <Navigate to="/" replace />; // Redireciona para home se não for admin
  }
};
export default AdminRoute;